/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

/**
 * Detect browser transform property.
 */
export const transformProperty = (function () {
    let elementStyle = document.createElement('div').style, properties = [
        'transform',
        '-ms-transform',
        '-moz-transform',
        '-webkit-transform'
    ];

    for (const prop of properties) {
        if (prop in elementStyle) {
            return prop;
        }
    }

    return properties[0];
})();

/**
 * Detect browser transition end event.
 */
export const transitionEvent = (function () {
    let elementStyle = document.createElement('div').style, transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    } as { [type: string]: string; };

    for (const transition in transitions) {
        if (transitions.hasOwnProperty(transition) && transition in elementStyle) {
            return transitions[transition];
        }
    }
})();
